import { useContext } from "react";
import { EditorContext, EditorContextValue } from "./EditorContext";

const useEditorContext = (): EditorContextValue => {
  const context = useContext(EditorContext);

  if (context === undefined) {
    throw new Error("useEditorContext must be used within an EditorProvider");
  }
  return context;
};

export default useEditorContext;
